import VueCookieComply from 'vue-cookie-comply-with-reject'
import type { App } from 'vue'
import type { Plugin } from '#app'
import { defineNuxtPlugin } from '#app'

const vueCookieComply: Plugin = defineNuxtPlugin(({ vueApp }: { vueApp: App<Element> }) => {
  vueApp.use(VueCookieComply)
})
export default vueCookieComply
